import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoIcon from '@mui/icons-material/Info';
import PersonOffIcon from '@mui/icons-material/PersonOff';

export default function ConfirmDialog(props) {

  const buttonAgree = () => {
    if (props.agree === "Desativar") {
      return (
        <Button
          onClick={props.handleAgreeDialog}
          variant="contained"
          color="warning"
          startIcon={<PersonOffIcon />}>
          {props.agree}
        </Button>
      );
    } else {
      return (
        <Button
          onClick={props.handleAgreeDialog}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}>
          {props.agree}
        </Button>
      );
    }
  };


  return (
    <Dialog
      closeAfterTransition={false}
      open={props.openConfirmDialog}
      onClose={props.handleCloseDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      role="alertdialog"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
          <InfoIcon sx={{ display: 'flex' }} />
          <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
            {props.title}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            pt: 3,
            minWidth: { xs: 'auto', sm: 300 },
            textAlign: 'center',
          }}>
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button
          onClick={props.handleCloseDialog}
          variant="outlined"
          startIcon={<ArrowBackIcon />}>
          {props.disagree}
        </Button>
        {buttonAgree()}
      </DialogActions>
    </Dialog>
  );
}
